export default __webpack_public_path__ + "static/media/ICON_mockups.96c31820.png";